<script>
</script>

<footer
  class="flex-1 w-full bg-coopmaths-canvas dark:bg-coopmathsdark-canvas h-12 flex justify-center bottom-0 opacity-100"
>
  <a href="/" target="_blank">
    <img
      class="px-6"
      style="height: 30px"
      src="assets/images/logo2.png"
      alt="Logo Coopmaths 2"
    />
  </a>
</footer>
